import React from 'react';

export const AnimatedLabel = ({ text, hoverClass = '' }) => (
  <span className="inline-flex flex-nowrap" aria-label={text}>
    {String(text).split('').map((ch, i) => (
      <span
        key={i}
        className={`inline-block transition-all duration-300 group-hover:-translate-y-0.5 ${hoverClass}`}
        style={{ transitionDelay: `${i * 40}ms` }}
        aria-hidden="true"
      >
        {ch === ' ' ? '\u00A0' : ch}
      </span>
    ))}
  </span>
);

export default AnimatedLabel;
